type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    gtag?: Gtag;
  }
}

export function trackRegisterClick(section: string, label?: string) {
  if (typeof window === "undefined" || !window.gtag) return;

  window.gtag("event", "register_click", {
    section,
    click_label: label ?? "",
  });
}
